import React from 'react'

import { EuiConfirmModal, EuiOverlayMask } from '@elastic/eui'
import { EuiConfirmModalProps } from '@elastic/eui/src/components/modal/confirm_modal'

export interface IAcConfirmModal extends EuiConfirmModalProps {
  message: string
}

export const AcConfirmModal: React.FC<IAcConfirmModal> = props => {
  return (
    <EuiOverlayMask>
      <EuiConfirmModal {...props}>
        <p style={{ whiteSpace: 'pre-wrap' }}>{props.message}</p>
        {props.children}
      </EuiConfirmModal>
    </EuiOverlayMask>
  )
}
